export const servicesContent = {
  litigation: {
    slug: "litigation",
    pageTitle: "עורך דין ליטיגציה בבאר שבע | משרד וידבסקי ושות׳",
    metaDescription:
      "עורך דין ליטיגציה בבאר שבע — ייצוג בבתי משפט השלום, המחוזי, בוררויות וגישור. ניסיון רב בתביעות אזרחיות ומסחריות. צרו קשר לייעוץ ראשוני.",
    breadcrumb: "ליטיגציה ויישוב סכסוכים",
    h1: "ליטיגציה ויישוב סכסוכים",
    heroSubtitle:
      "ייצוג חד וממוקד בכל הערכאות — מבית משפט השלום ועד לבית המשפט המחוזי, לרבות בוררות וגישור. אנחנו נלחמים על האינטרסים שלכם בכל סכסוך.",
    introSpan: "תחום ההתמחות",
    introTitle: "ייצוג מקצועי בכל סוגי ההליכים",
    introParagraphs: [
      "ליטיגציה היא אומנות ניהול הסכסוך המשפטי — שילוב של חשיבה אסטרטגית, שליטה דיונית, ניסיון אולמי וכושר מו״מ. משרד וידבסקי ושות׳ מתמחה בליטיגציה אזרחית ומסחרית, ומייצג לקוחות פרטיים, בעלי עסקים, חברות ותאגידים בכל רחבי הארץ.",
      "אנו מאמינים כי לא כל סכסוך חייב להגיע לכותלי בית המשפט. במקרים המתאימים נקדם הסדר משפטי בגישור או בבוררות, ובמקרים בהם נדרש ייצוג בבית המשפט — אנו מנהלים את התיק במקצועיות, נחישות וביסודיות.",
    ],
    introBullets: [
      "ייצוג בתביעות אזרחיות ומסחריות",
      "ייצוג בבית משפט השלום, המחוזי וערעורים",
      "בוררויות, גישורים והליכי יישוב סכסוכים",
      "צווי מניעה זמניים וצווים דחופים",
      "ניהול תיקים מורכבים מרובי צדדים",
      "אסטרטגיה משפטית מותאמת אישית לכל לקוח",
    ],
    cardsTitle: "תחומי הטיפול בליטיגציה",
    cardsSpan: "במה אנחנו מטפלים",
    cards: [
      {
        icon: "⚖️",
        title: "תביעות אזרחיות",
        desc: "ייצוג בתביעות חוזיות, נזיקיות, כספיות וקנייניות — בכל סדרי הדין.",
      },
      {
        icon: "🏢",
        title: "סכסוכים מסחריים",
        desc: "תביעות בין שותפים, סכסוכי בעלי מניות, הפרות הסכמים והתחשבנויות עסקיות.",
      },
      {
        icon: "🤝",
        title: "גישור ובוררות",
        desc: "ייצוג בהליכים חלופיים ליישוב סכסוכים — מהירים, חסויים וחסכוניים.",
      },
      {
        icon: "🛡️",
        title: "צווים זמניים",
        desc: "צווי מניעה, צווי עיקול, צווי תפיסת נכסים — שמירה על זכויותיכם בזמן אמת.",
      },
      {
        icon: "📜",
        title: "ערעורים",
        desc: "הגשה והתנגדות לערעורים בבית המשפט המחוזי ובבית המשפט העליון.",
      },
      {
        icon: "🧾",
        title: "הוצאה לפועל של פסקי דין",
        desc: "מימוש פסיקה לטובתכם — גביית חובות בפועל וצעדי אכיפה אפקטיביים.",
      },
    ],
    processSpan: "תהליך הטיפול",
    processTitle: "איך אנחנו מנהלים תיק ליטיגציה?",
    processSteps: [
      {
        n: "1",
        title: "ניתוח ראשוני ובחינת התיק",
        desc: "נשמע את גרסתכם, נבחן את המסמכים והראיות, ונעריך את סיכויי ההצלחה והסיכונים בכנות מלאה.",
      },
      {
        n: "2",
        title: "גיבוש אסטרטגיה משפטית",
        desc: "נבנה תוכנית פעולה מותאמת — האם לפתוח במגעי פשרה, להגיש תביעה, לבקש סעד דחוף או לנהל הליך חלופי.",
      },
      {
        n: "3",
        title: "ניהול ההליך מקצה לקצה",
        desc: "כתבי טענות, חקירות, ניהול דיונים — אנו מובילים את התיק עד להכרעה הסופית, תוך עדכון שוטף בכל שלב.",
      },
      {
        n: "4",
        title: "מימוש התוצאה",
        desc: "לאחר הפסיקה — ננחה אתכם בצעדים הבאים: הוצאה לפועל, ערעור או יישום ההסדר שהושג.",
      },
    ],
    faqSpan: "שאלות נפוצות",
    faqTitle: "שאלות על ליטיגציה",
    faqItems: [
      {
        q: "מתי כדאי לפתוח בהליך משפטי?",
        a: "ככלל, יש לפנות לעורך דין מוקדם ככל האפשר — עוד לפני הגשת תביעה. ייעוץ מוקדם יכול לחסוך זמן, כסף ולעיתים אף את עצם ההליך, באמצעות פתרון בדרכים חלופיות.",
      },
      {
        q: "כמה זמן נמשך הליך משפטי?",
        a: "משך ההליך משתנה משמעותית לפי סוג התיק והערכאה: הליכים בסדר דין מהיר עשויים להסתיים תוך חודשים, בעוד תביעות מורכבות יכולות להימשך שנים. אנו פועלים תמיד לקיצור משך ההליך עד כמה שניתן.",
      },
      {
        q: "מה ההבדל בין גישור לבוררות?",
        a: "בגישור הצדדים מנסים להגיע להסכם בעצמם בעזרת מגשר ניטרלי, ללא הכרעה כפויה. בבוררות הבורר מקבל החלטה מחייבת. שתי החלופות מהירות וחסויות מההליך השיפוטי הרגיל.",
      },
      {
        q: "האם תמיד צריך לקבוע פגישה פיזית?",
        a: "פגישה פיזית מומלצת בתיקים מורכבים, אך ניתן לקיים פגישות ייעוץ גם בשיחת וידאו או טלפון — לפי נוחותכם וצורך התיק.",
      },
      {
        q: "מה קורה אם אני מפסיד בתיק?",
        a: "במקרים מסוימים ניתן להגיש ערעור לערכאה גבוהה יותר. בנוסף, ניתן לעיתים לבטל פסק דין שניתן בהיעדר הגנה. במשרד נבחן את האפשרויות העומדות בפניכם בכל שלב.",
      },
    ],
    ctaTitle: "סכסוך משפטי? אנחנו כאן בשבילכם",
    ctaText: "ככל שתפנו מוקדם יותר — כך נוכל לפעול נכון יותר. צרו קשר לייעוץ ראשוני.",
  },

  "real-estate": {
    slug: "real-estate",
    pageTitle: "עורך דין נדל״ן בבאר שבע | משרד וידבסקי ושות׳",
    metaDescription:
      "עורך דין נדל״ן בבאר שבע — ליווי ברכישה ומכירת דירות ונכסים, מיסוי מקרקעין, חוזים ועסקאות נדל״ן. שקיפות, מקצועיות וניסיון רב.",
    breadcrumb: "נדל״ן ומיסוי מקרקעין",
    h1: "נדל״ן ומיסוי מקרקעין",
    heroSubtitle:
      "עסקת נדל״ן היא מהעסקאות הגדולות והמשמעותיות בחיים. אצלנו תקבלו ליווי משפטי מקצועי, יסודי ומלא — מההסכם הראשוני ועד למסירת המפתח.",
    introSpan: "תחום ההתמחות",
    introTitle: "ליווי משפטי לעסקת נדל״ן בטוחה",
    introParagraphs: [
      "תחום הנדל״ן הוא אחד הסבוכים והרגישים ביותר במשפט הישראלי. עסקה לא תקינה עלולה לעלות מאות אלפי שקלים, ולעיתים אף להוביל לאובדן הזכויות בנכס. משרד וידבסקי ושות׳ מלווה לקוחות בכל סוגי עסקאות הנדל״ן — דירות יד שנייה, רכישה מקבלן, נכסים מסחריים וקרקעות.",
      "אנו מקפידים על בדיקה מעמיקה של מצבם המשפטי של הנכסים, ניהול מו״מ נחוש על תנאי ההסכם, ליווי בכל הליכי המיסוי והרישום, ושמירה על הכספים בנאמנות בטוחה — לאורך כל הדרך.",
    ],
    introBullets: [
      "רכישה ומכירת דירות יד שנייה",
      "רכישה מקבלן ובדיקת חוזי מכר",
      "עסקאות במגרשים ובנכסים מסחריים",
      "מיסוי מקרקעין — מס שבח, מס רכישה והיטל השבחה",
      "צוואות והעברת זכויות במקרקעין",
      "ייצוג בסכסוכי שכנים, בית משותף ותמ״א",
    ],
    cardsTitle: "תחומי הטיפול בנדל״ן",
    cardsSpan: "במה אנחנו מטפלים",
    cards: [
      {
        icon: "🏠",
        title: "דירות יד שנייה",
        desc: "ליווי מלא של הקונה והמוכר — בדיקה רישומית, מו״מ, חוזה והעברת זכויות בטאבו.",
      },
      {
        icon: "🏗️",
        title: "רכישה מקבלן",
        desc: "בחינת הסכם הרכישה, פוליסות הביטוח, הערות אזהרה, התאמות ולוחות זמנים.",
      },
      {
        icon: "📊",
        title: "מיסוי מקרקעין",
        desc: "תכנון מס מקדים, הפחתת מס שבח ומס רכישה, השגות על שומות ופטורים.",
      },
      {
        icon: "🏢",
        title: "נדל״ן מסחרי",
        desc: "רכישה, מכירה והשכרה של נכסים מסחריים — משרדים, חנויות ומגרשים.",
      },
      {
        icon: "📑",
        title: "הסכמי שכירות",
        desc: "עריכת חוזי שכירות מסחריים ופרטיים, ייצוג במחלוקות והפרות.",
      },
      {
        icon: "🔄",
        title: "תמ״א 38 ופינוי-בינוי",
        desc: "ייצוג דיירים בעסקאות התחדשות עירונית, בחינת חוזים מול יזמים.",
      },
    ],
    processSpan: "תהליך הטיפול",
    processTitle: "איך מתנהלת אצלנו עסקת נדל״ן?",
    processSteps: [
      {
        n: "1",
        title: "פגישת ייעוץ ובדיקות מקדימות",
        desc: "נכיר את העסקה, נבצע בדיקה רישומית בטאבו וברשות מקרקעי ישראל, ונבחן את ההיבטים התכנוניים, המשפטיים והמיסויים.",
      },
      {
        n: "2",
        title: "מו״מ ועריכת חוזה",
        desc: "ננהל מו״מ עם הצד השני, נערוך ונתאים את החוזה לצרכים ולסיכונים, ונעגן בחוזה את כל ההגנות הדרושות.",
      },
      {
        n: "3",
        title: "ליווי הביצוע",
        desc: "רישום הערת אזהרה, פתיחת חשבונות נאמנות, דיווח לרשויות המס, תשלום מס שבח ומס רכישה — הכל מתחת לגג אחד.",
      },
      {
        n: "4",
        title: "השלמת העסקה ורישום",
        desc: "מסירת החזקה, סילוק שעבודים והעברת הבעלות בטאבו על שמכם — סוגרים את העסקה כראוי.",
      },
    ],
    faqSpan: "שאלות נפוצות",
    faqTitle: "שאלות על נדל״ן ומיסוי מקרקעין",
    faqItems: [
      {
        q: "האם חובה להיעזר בעורך דין בעסקת נדל״ן?",
        a: "מבחינה חוקית — לא חובה, אך מבחינה מעשית — אסור לוותר על כך. עורך הדין מבטיח שהעסקה תקינה משפטית, נקייה משעבודים, בעלת תנאי תשלום בטוחים, ומיוצגת נכון מול רשויות המס. עלות הליווי קטנה ביחס לסיכונים שהוא מונע.",
      },
      {
        q: "כמה עולה עורך דין בעסקת נדל״ן?",
        a: "שכר הטרחה משתנה לפי סוג העסקה ושוויה. אנו מציעים שקיפות מלאה כבר בפגישת הייעוץ הראשונית — תקבלו הצעת מחיר ברורה ללא הפתעות.",
      },
      {
        q: "מה זה מס שבח ומתי משלמים אותו?",
        a: "מס שבח הוא מס המוטל על הרווח שנוצר ממכירת זכות במקרקעין. הוא משולם על ידי המוכר, וקיימים פטורים והקלות שונים — שעלולים להיות שווים עשרות אלפי שקלים. תכנון מס מקדים הוא קריטי.",
      },
      {
        q: "מה ההבדל בין דירת יד ראשונה ליד שנייה משפטית?",
        a: "ברכישה מקבלן הצד החזק הוא הקבלן, החוזה ארוך ומורכב, וקיימים סיכונים ייחודיים (איחורי מסירה, ליקויי בנייה, חוק המכר). בעסקת יד שנייה הסיכון העיקרי הוא במצב הרישומי של הנכס. כל סוג דורש בדיקה ייחודית.",
      },
      {
        q: "כמה זמן נמשכת עסקת נדל״ן?",
        a: "עסקה ממוצעת אורכת בין חודשיים לחצי שנה — בהתאם למורכבות, להסדרי המימון ולאופן רישום הזכויות. אנו פועלים לסיום מהיר תוך שמירה על איכות הטיפול.",
      },
    ],
    ctaTitle: "מתכננים עסקת נדל״ן?",
    ctaText: "פנו אלינו לפני שאתם חותמים — בדיקה מוקדמת חוסכת בעיות גדולות בהמשך.",
  },

  torts: {
    slug: "torts",
    pageTitle: "עורך דין נזיקין בבאר שבע | פיצויים בתאונות ורשלנות רפואית",
    metaDescription:
      "עורך דין נזיקין בבאר שבע — ייצוג בתביעות תאונות דרכים, תאונות עבודה ורשלנות רפואית. אנו נלחמים על הפיצוי המלא שמגיע לכם.",
    breadcrumb: "נזיקין ופיצויים",
    h1: "עורך דין נזיקין",
    heroSubtitle:
      "נפצעתם בתאונה? סבלתם מרשלנות? אתם זכאים לפיצוי. משרד וידבסקי ושות׳ נלחם על מלוא הפיצוי שמגיע לכם — מול חברות הביטוח, המעסיקים ובתי המשפט.",
    introSpan: "תחום ההתמחות",
    introTitle: "ייצוג נפגעים בכל סוגי התביעות הנזיקיות",
    introParagraphs: [
      "נפגעי תאונות ורשלנות עומדים פעמים רבות מול חברות ביטוח חזקות שמטרתן להפחית את הפיצוי. בלי ייצוג מקצועי, רוב הנפגעים מקבלים פחות ממה שמגיע להם — לעיתים בעשרות אחוזים. במשרד וידבסקי ושות׳ אנו דואגים שכל לקוח יקבל את מלוא הפיצוי לו הוא זכאי על פי דין.",
      "בתחום הנזיקין הזמן הוא קריטי. ראיות נעלמות, עדים שוכחים, ולעיתים מתחילים תקופות התיישנות שעלולות לחסום את התביעה. ככל שתפנו מוקדם יותר — כך סיכויי ההצלחה גבוהים יותר.",
    ],
    introBullets: [
      "תאונות דרכים — נפגעי גוף ורכוש",
      "תאונות עבודה ופגיעות בעבודה",
      "רשלנות רפואית והזנחה רפואית",
      "תאונות אישיות — נפילות, פגיעות בפנאי",
      "נזקי גוף בתקיפות אלימות",
      "תביעות מול המוסד לביטוח לאומי",
    ],
    cardsTitle: "תחומי הטיפול בנזיקין",
    cardsSpan: "במה אנחנו מטפלים",
    cards: [
      {
        icon: "🚗",
        title: "תאונות דרכים",
        desc: "תביעות נפגעי גוף לפי חוק הפלת״ד — מול חברות הביטוח ומול קרנית.",
      },
      {
        icon: "🏭",
        title: "תאונות עבודה",
        desc: "תביעות מול המוסד לביטוח לאומי, ותביעות אזרחיות מול מעסיקים.",
      },
      {
        icon: "⚕️",
        title: "רשלנות רפואית",
        desc: "ייצוג מול בתי חולים, רופאים וקופות החולים — בליווי רופאים יועצים.",
      },
      {
        icon: "🤕",
        title: "תאונות אישיות",
        desc: "נפילות במקומות ציבוריים, פגיעות בפנאי, תאונות בבריכה ובחדר כושר.",
      },
      {
        icon: "🛡️",
        title: "תביעות ביטוח",
        desc: "תביעות מול חברות ביטוח שדוחות תביעה או מציעות פיצוי לא הוגן.",
      },
      {
        icon: "👨‍⚖️",
        title: "ועדות רפואיות",
        desc: "ייצוג בוועדות הביטוח הלאומי לקביעת אחוזי נכות — שלב קריטי לגובה הפיצוי.",
      },
    ],
    processSpan: "תהליך הטיפול",
    processTitle: "איך אנחנו מנהלים תביעת נזיקין?",
    processSteps: [
      {
        n: "1",
        title: "פגישת ייעוץ והערכה",
        desc: "נשמע את הסיפור שלכם, נבחן את האירוע ואת הנזק, ונעריך בכנות מלאה את גובה הפיצוי הצפוי.",
      },
      {
        n: "2",
        title: "איסוף ראיות וחוות דעת",
        desc: "נשיג מסמכים רפואיים, נבצע חקירות, ונזמין חוות דעת רפואיות ושמאיות — היסוד לתביעה חזקה.",
      },
      {
        n: "3",
        title: "מו״מ עם חברת הביטוח",
        desc: "במרבית המקרים ניתן להגיע להסדר משמעותי לפני הגשת תביעה. אנו מנהלים מו״מ נחוש מתוך עמדת כוח.",
      },
      {
        n: "4",
        title: "ייצוג בבית המשפט",
        desc: "כשנדרש — נגיש תביעה ונייצג אתכם בכל שלב, עד לקבלת הפיצוי המלא בפועל.",
      },
    ],
    faqSpan: "שאלות נפוצות",
    faqTitle: "שאלות על תביעות נזיקין",
    faqItems: [
      {
        q: "כמה זמן יש לי להגיש תביעת נזיקין?",
        a: "ככלל, תקופת ההתיישנות בתביעות נזיקין היא 7 שנים מיום האירוע. אך קיימים חריגים רבים — קטינים, נזקים שהתגלו מאוחר ועוד. גם אם נדמה שעבר זמן רב, פנו לייעוץ מיידי.",
      },
      {
        q: "האם לעו״ד נזיקין יש שכר טרחה מותנה?",
        a: "כן. בתביעות נזיקין נהוג שכר טרחה מותנה הצלחה — אחוזים מהפיצוי שתקבלו. אם אין פיצוי — אין שכר טרחה. כך אנחנו ואתם עומדים יחד באותו צד של המתרס.",
      },
      {
        q: "האם נדרשת חוות דעת רפואית בכל מקרה?",
        a: "ברוב המכריע של תביעות הנזיקין שיש בהן פגיעת גוף — כן. חוות הדעת הרפואית היא יסוד הקובע את שיעור הנזק והפיצוי. אנו עובדים עם רופאים מומחים בכל התחומים.",
      },
      {
        q: "מה קורה בוועדה רפואית של הביטוח הלאומי?",
        a: "הוועדה קובעת את אחוזי הנכות שיוכרו לכם, שמשפיעים ישירות על הקצבאות והפיצויים. ייצוג מקצועי בוועדה — או בערר עליה — יכול להגדיל את הפיצוי באופן משמעותי.",
      },
      {
        q: "האם עליי לקבל הצעה ראשונה של חברת הביטוח?",
        a: "מומלץ מאוד לא! חברות הביטוח מציעות בשלב מוקדם סכום נמוך, בידיעה שנפגעים נואשים יסכימו. תמיד עדיף להתייעץ עם עורך דין לפני קבלת כל הצעה.",
      },
    ],
    ctaTitle: "נפגעתם? מגיע לכם פיצוי",
    ctaText: "הפגישה הראשונה ללא תשלום ושכר הטרחה מותנה הצלחה. צרו קשר עוד היום.",
  },

  family: {
    slug: "family",
    pageTitle: "עורך דין דיני משפחה בבאר שבע | משרד וידבסקי ושות׳",
    metaDescription:
      "עורך דין דיני משפחה בבאר שבע — גירושין, הסכמי ממון, צוואות וירושות, ייפוי כוח מתמשך. ליווי רגיש, מקצועי ודיסקרטי בכל הליך משפחתי.",
    breadcrumb: "דיני משפחה",
    h1: "עורך דין דיני משפחה",
    heroSubtitle:
      "ענייני משפחה דורשים רגישות לצד מקצועיות. משרד וידבסקי ושות׳ מלווה אתכם באחריות, בדיסקרטיות ובהבנה — בנושאי גירושין, ירושות, הסכמי ממון ועוד.",
    introSpan: "תחום ההתמחות",
    introTitle: "ליווי משפטי בכל שלבי החיים המשפחתיים",
    introParagraphs: [
      "דיני המשפחה נוגעים לצמתים הרגישים והחשובים ביותר בחיינו — נישואין, גירושין, חינוך הילדים, רכוש משותף וירושה. החלטות בתחום זה משפיעות לא רק עלינו, אלא על הדורות הבאים.",
      "במשרד וידבסקי ושות׳ נלווה אתכם בקור רוח ובמקצועיות, נפעל ככל הניתן להגיע להסכמות מחוץ לכותלי בית המשפט, ובמקרי הצורך — נייצג אתכם בנחישות בכל ערכאה. שמירה על האינטרסים הכלכליים, האישיים והמשפחתיים שלכם היא בראש סדר העדיפויות שלנו.",
    ],
    introBullets: [
      "גירושין בהסכמה ובמחלוקת",
      "הסכמי ממון לפני ובמהלך הנישואין",
      "מזונות ילדים ומשמורת",
      "צוואות, ירושות והתנגדויות",
      "ייפוי כוח מתמשך והנחיות מקדימות",
      "אפוטרופסות וייצוג בענייני קטינים",
    ],
    cardsTitle: "תחומי הטיפול בדיני משפחה",
    cardsSpan: "במה אנחנו מטפלים",
    cards: [
      {
        icon: "💍",
        title: "גירושין",
        desc: "ליווי בהליכי גירושין בהסכמה, בגישור או בבית הדין — תוך הגנה על האינטרסים שלכם.",
      },
      {
        icon: "📝",
        title: "הסכמי ממון",
        desc: "עריכת הסכמי ממון לפני נישואין ובמהלכם — הגנה על הרכוש לעתיד לבוא.",
      },
      {
        icon: "👨‍👩‍👧",
        title: "מזונות ומשמורת",
        desc: "ייצוג בענייני משמורת ילדים, הסדרי שהות ומזונות — לטובת הילדים ולטובתכם.",
      },
      {
        icon: "📜",
        title: "צוואות וירושות",
        desc: "עריכת צוואות, התנגדויות לצוואה, חלוקת עיזבון וניהול הליכי ירושה.",
      },
      {
        icon: "🤲",
        title: "ייפוי כוח מתמשך",
        desc: "תכנון מי יטפל בענייניכם אם תאבדו כשירות — הגנה על אוטונומיה אישית.",
      },
      {
        icon: "🏘️",
        title: "חלוקת רכוש",
        desc: "ליווי בחלוקת רכוש, פנסיות, חסכונות ונכסי קריירה בין בני זוג מתגרשים.",
      },
    ],
    processSpan: "תהליך הטיפול",
    processTitle: "איך מתנהל הליך בדיני משפחה?",
    processSteps: [
      {
        n: "1",
        title: "פגישה דיסקרטית והערכת המצב",
        desc: "נקיים פגישה רגישה ופרטית, נבין את המצב המשפחתי, הכלכלי והרגשי, ונציג את האפשרויות העומדות בפניכם.",
      },
      {
        n: "2",
        title: "ניסיון להסדר בהסכמה",
        desc: "ככל שניתן, נפעל להגיע להסדר במו״מ או בגישור — דרך מהירה, חסכונית ומכבדת יותר מהליך משפטי.",
      },
      {
        n: "3",
        title: "ייצוג בבתי המשפט",
        desc: "כשנדרש, נייצג בבית המשפט לענייני משפחה או בבית הדין הרבני — לפי המקום המתאים והאסטרטגיה הנכונה.",
      },
      {
        n: "4",
        title: "מימוש פסק הדין",
        desc: "אנו מלווים גם לאחר ההכרעה — בביצוע פסקי דין, התאמת הסדרים והתמודדות עם שינויי נסיבות עתידיים.",
      },
    ],
    faqSpan: "שאלות נפוצות",
    faqTitle: "שאלות על דיני משפחה",
    faqItems: [
      {
        q: "מה ההבדל בין גירושין בבית המשפט ובבית הדין הרבני?",
        a: "בית הדין הרבני מוסמך לדון בעצם הגירושין (גט). בית המשפט לענייני משפחה דן בשאר הסוגיות — רכוש, מזונות, משמורת. לעיתים יש מאבק ״סמכויות״ — מי שמגיש ראשון רוכש יתרון. ייעוץ מוקדם הוא קריטי.",
      },
      {
        q: "האם הסכם ממון מבטיח שלא נסתבך בגירושין?",
        a: "הסכם ממון תקף ומאושר בבית המשפט מסדיר את חלוקת הרכוש ועוזר משמעותית במקרה של פרידה. הוא לא מונע את הסכסוך, אך מצמצם משמעותית את היקפו ואת אורך ההליך.",
      },
      {
        q: "מי משלם מזונות ילדים?",
        a: "ההלכה הפסוקה השתנתה בשנים האחרונות. כיום נלקחים בחשבון רמת ההכנסה של שני ההורים, חלוקת זמני השהות והוצאות הילדים בפועל. אין נוסחה אחידה — כל מקרה נבחן לגופו.",
      },
      {
        q: "מה זה ייפוי כוח מתמשך?",
        a: "מסמך משפטי המאפשר לכם לקבוע מראש מי יטפל בענייניכם — רכושיים, אישיים ורפואיים — אם בעתיד תאבדו כשירות. זהו תחליף מודרני, מכבד וחסכוני להליך מינוי אפוטרופוס.",
      },
      {
        q: "כמה עולה ליווי משפטי בגירושין?",
        a: "העלות תלויה בסוג ההליך — בהסכמה לעומת מאבק. בגירושין בהסכמה השכר נמוך משמעותית. אנו עובדים בשקיפות מלאה — תקבלו הצעת מחיר ברורה כבר בפגישה הראשונה.",
      },
    ],
    ctaTitle: "צריכים ליווי בדיני משפחה?",
    ctaText: "פנייה מוקדמת חוסכת זמן, כסף וכאב לב. צרו קשר לייעוץ דיסקרטי.",
  },

  commercial: {
    slug: "commercial",
    pageTitle: "עורך דין מסחרי ותאגידי בבאר שבע | משרד וידבסקי ושות׳",
    metaDescription:
      "עורך דין מסחרי בבאר שבע — ליווי משפטי לעסקים, חברות וסטארט-אפים. עריכת חוזים, הקמת חברות, השקעות וייעוץ שוטף.",
    breadcrumb: "משפט מסחרי ותאגידי",
    h1: "משפט מסחרי ותאגידי",
    heroSubtitle:
      "מהקמת החברה ועד הסכמי השקעה — אנו בצד שלכם. משרד וידבסקי ושות׳ הוא הזרוע המשפטית של עסקים, חברות וסטארט-אפים בנגב ובכל הארץ.",
    introSpan: "תחום ההתמחות",
    introTitle: "שותף משפטי לעסק שלכם",
    introParagraphs: [
      "ניהול עסק היום מצריך התמודדות יומיומית עם שאלות משפטיות — חוזים, רגולציה, יחסי עבודה, מיסוי, מבנה תאגידי וגיוס הון. עורך דין מסחרי טוב הוא לא רק מי שמטפל בבעיות — הוא שותף אמיתי שעוזר לכם להימנע מהן מלכתחילה.",
      "במשרד וידבסקי ושות׳ אנו מלווים עסקים בכל גודל — מעצמאים ועסקים קטנים ועד חברות גדולות וסטארט-אפים. אנו מציעים שירות אישי, זמין ומותאם, עם הבנה עמוקה של עולם העסקים והשפה של אנשי המעשה.",
    ],
    introBullets: [
      "הקמת חברות, שותפויות ועמותות",
      "עריכת חוזים מסחריים והסכמי שירות",
      "הסכמי מייסדים והסכמי בעלי מניות",
      "ליווי גיוסי הון, השקעות ועסקאות M&A",
      "ייעוץ שוטף לעסקים — Retainer",
      "התמודדות עם רגולציה ורישוי",
    ],
    cardsTitle: "תחומי הטיפול במשפט מסחרי",
    cardsSpan: "במה אנחנו מטפלים",
    cards: [
      {
        icon: "🏢",
        title: "הקמת חברות",
        desc: "רישום חברות בע״מ, שותפויות, עמותות וחל״צ — בליווי מלא ובתכנון נכון מהיום הראשון.",
      },
      {
        icon: "📋",
        title: "חוזים מסחריים",
        desc: "עריכה ובדיקה של חוזי שירות, הפצה, סוכנות, אספקה ושיתופי פעולה.",
      },
      {
        icon: "🤝",
        title: "הסכמי מייסדים",
        desc: "בניית שותפות עסקית יציבה — חלוקת מניות, סמכויות, חזרת מניות ופתרון מחלוקות.",
      },
      {
        icon: "🚀",
        title: "סטארט-אפים והייטק",
        desc: "ליווי גיוסי הון, הסכמי משקיעים, אופציות לעובדים ועסקאות יציאה.",
      },
      {
        icon: "💼",
        title: "ייעוץ שוטף לעסקים",
        desc: "Retainer חודשי — זמינות מלאה לכל שאלה משפטית, ללא הגבלת זמן.",
      },
      {
        icon: "⚖️",
        title: "סכסוכים מסחריים",
        desc: "ייצוג בסכסוכים בין שותפים, הפרות חוזה ותחרות בלתי הוגנת.",
      },
    ],
    processSpan: "תהליך הטיפול",
    processTitle: "איך אנחנו עובדים עם עסקים?",
    processSteps: [
      {
        n: "1",
        title: "הכרות עם העסק והצרכים",
        desc: "נכיר את התחום שלכם, את אנשי המפתח, את היעדים ואת האתגרים — כדי לתפור מענה מדויק.",
      },
      {
        n: "2",
        title: "מיפוי סיכונים והזדמנויות",
        desc: "נבצע מיפוי משפטי של העסק — חוזים קיימים, הסכמים פנימיים ומבנה תאגידי. נצביע על מה שדורש שיפור.",
      },
      {
        n: "3",
        title: "ליווי שוטף וטיפול בעסקאות",
        desc: "אנו זמינים לכל שאלה — מחוזה קצר ועד עסקה משמעותית. עם או בלי Retainer, לפי מה שמתאים לכם.",
      },
      {
        n: "4",
        title: "התמודדות עם משברים",
        desc: "כשמתעוררת בעיה — אנו פועלים מהר, עם מינימום עלויות ופגיעה בעסק.",
      },
    ],
    faqSpan: "שאלות נפוצות",
    faqTitle: "שאלות על משפט מסחרי",
    faqItems: [
      {
        q: "מתי כדאי להקים חברה בע״מ?",
        a: "ככלל, כדאי לעבור לחברה בע״מ כשההכנסות חורגות מסף מסוים, כשאתם רוצים להפריד אחריות אישית מעסקית, או כשאתם מתכננים גיוס משקיעים. ייעוץ משולב — משפטי וחשבונאי — יעזור לכם לקבל החלטה מושכלת.",
      },
      {
        q: "מה זה Retainer ומתי הוא משתלם?",
        a: "Retainer הוא תשלום חודשי קבוע תמורת זמינות משפטית מלאה. הוא משתלם לעסקים פעילים שזקוקים למענה מהיר וקבוע — בלי הפתעות בחשבון. נציע לכם הסדר מותאם אישית.",
      },
      {
        q: "האם חובה להחתים על הסכם מייסדים?",
        a: "אין חובה חוקית, אך זו הטעות הנפוצה ביותר של יזמים. הסכם מייסדים יציל את העסק שלכם ברגע מחלוקת — והרבה לפני זה, יחדד את הציפיות בין השותפים. הכינו אותו בשלב ההתחלה.",
      },
      {
        q: "כמה עולה ליווי לסטארט-אפ?",
        a: "אנו מתאימים את המודל לשלב בו נמצא הסטארט-אפ — מ-Retainer מוזל בשלבי Pre-Seed ועד ליווי מלא בעסקאות גיוס משמעותיות. גם תשלום בעסקאות מורכבות ניתן לפרוס.",
      },
      {
        q: "האם אתם מטפלים בעסקאות M&A?",
        a: "כן. אנו מלווים מיזוגים, רכישות ועסקאות יציאה — מהמו״מ הראשוני ועד ה-Closing, כולל בדיקות נאותות, מסמכי עסקה ושמירה על האינטרסים שלכם.",
      },
    ],
    ctaTitle: "מחפשים יועץ משפטי לעסק?",
    ctaText: "פנו אלינו לייעוץ מקצועי וזמין — ובואו נצמיח את העסק שלכם יחד.",
  },

  insolvency: {
    slug: "insolvency",
    pageTitle: "עורך דין חדלות פירעון ופשיטת רגל בבאר שבע | וידבסקי ושות׳",
    metaDescription:
      "עורך דין חדלות פירעון ופשיטת רגל בבאר שבע — הליכי הפטר, הסדרי נושים ושיקום כלכלי. אנו נחזיר אתכם לחיים נורמליים.",
    breadcrumb: "חדלות פירעון ופשיטות רגל",
    h1: "חדלות פירעון ופשיטות רגל",
    heroSubtitle:
      "אם אתם שקועים בחובות שאין דרך לפרוע — קיים פתרון משפטי שיחזיר אתכם לחיים נורמליים. משרד וידבסקי ושות׳ ילווה אתכם בהליכי חדלות פירעון בצורה מקצועית, אנושית ויעילה.",
    introSpan: "תחום ההתמחות",
    introTitle: "פתרון משפטי לחובות שלא ניתנים לפירעון",
    introParagraphs: [
      "חוק חדלות פירעון ושיקום כלכלי, התשע״ח-2018 חולל מהפכה בתחום פשיטת הרגל בישראל. במקום מערכת מלאת בושה ובידוד, נוצרה מערכת שמטרתה הצהרתית — שיקום כלכלי של החייב והחזרתו למסלול חיים תקין.",
      "אם הגעתם למצב בו אינכם יכולים עוד לפרוע את חובותיכם, פתיחת הליך חדלות פירעון יכולה להעניק לכם הקלה משמעותית: הקפאת ההוצאות לפועל, הסדר תשלומים לפי יכולת, ובסופו של דבר — הפטר מלא או חלקי מהחובות. אנו במשרד מלווים את הלקוחות שלנו בכל צעד, ברגישות ובמקצועיות.",
    ],
    introBullets: [
      "הליכי חדלות פירעון של יחידים",
      "הליכי חדלות פירעון של חברות",
      "הסדרי נושים ופשרה",
      "הפטר מחובות — מלא או חלקי",
      "הגנה על הבית והנכסים החיוניים",
      "ייצוג מול הנושים, הכונס הרשמי והנאמן",
    ],
    cardsTitle: "תחומי הטיפול בחדלות פירעון",
    cardsSpan: "במה אנחנו מטפלים",
    cards: [
      {
        icon: "👤",
        title: "חייבים יחידים",
        desc: "פתיחת הליך חדלות פירעון אישי, ייצוג בכל שלבי ההליך, השגת הפטר ושיקום כלכלי.",
      },
      {
        icon: "🏢",
        title: "חברות",
        desc: "הליכי הקפאת הליכים ופירוק חברות — מטעם החברה או הנושים.",
      },
      {
        icon: "🤝",
        title: "הסדרי נושים",
        desc: "ייצוג ביצירת הסדר חוב מסודר עם הנושים — מחוץ או בתוך הליך משפטי.",
      },
      {
        icon: "🏠",
        title: "הגנה על הבית",
        desc: "מאבק לשמירה על דירת המגורים גם בהליכי חדלות פירעון — כל מקרה לגופו.",
      },
      {
        icon: "📑",
        title: "הפטר מחובות",
        desc: "השגת הפטר מלא או חלקי שמשחרר אתכם מעול החובות ופותח דף חדש.",
      },
      {
        icon: "⚖️",
        title: "ייצוג נושים",
        desc: "ייצוג נושים בהליכי חדלות פירעון של חייבים — להגנה על האינטרסים שלכם.",
      },
    ],
    processSpan: "תהליך הטיפול",
    processTitle: "איך מתנהל הליך חדלות פירעון?",
    processSteps: [
      {
        n: "1",
        title: "פגישת ייעוץ ובחינת המצב",
        desc: "נמפה את כל החובות, ההכנסות, הנכסים והנסיבות. נציג בכנות אם הליך חדלות פירעון מתאים לכם — או שיש דרך טובה יותר.",
      },
      {
        n: "2",
        title: "הגשת בקשה לצו פתיחת הליכים",
        desc: "נכין ונגיש את הבקשה לממונה על חדלות פירעון. מרגע מתן הצו — כל הליכי הגבייה מוקפאים מיד.",
      },
      {
        n: "3",
        title: "תקופת חקירה וניהול ההליך",
        desc: "נלווה אתכם בחקירה הכלכלית, בהכנת התוכנית לפירעון ובדיווחים השוטפים — תוך מאמץ למזער את התקופה.",
      },
      {
        n: "4",
        title: "השגת הפטר ושיקום",
        desc: "בסופו של ההליך — צו ההפטר משחרר אתכם מהחובות. נסייע לכם להחזיר את החיים הכלכליים למסלול תקין.",
      },
    ],
    faqSpan: "שאלות נפוצות",
    faqTitle: "שאלות על חדלות פירעון",
    faqItems: [
      {
        q: "מי יכול להגיש בקשה לחדלות פירעון?",
        a: "כל אדם פרטי שחובותיו עולים על 50,000 ש״ח ואין באפשרותו לפרוע אותם, או כל חברה שאין באפשרותה לעמוד בהתחייבויותיה. גם נושה יכול להגיש בקשה כנגד חייב.",
      },
      {
        q: "האם אני אאבד את הבית והרכב בהליך?",
        a: "לא בהכרח. החוק מאפשר במקרים רבים לשמור על דירת המגורים ועל רכב חיוני. כל מקרה נבחן לגופו, לפי שווי הנכסים, היקף החוב, היכולת הכלכלית והאינטרסים של שני הצדדים.",
      },
      {
        q: "כמה זמן נמשך הליך חדלות פירעון?",
        a: "ההליך החדש קצוב בזמן — בדרך כלל בין שנתיים לארבע שנים, עד למתן ההפטר. זה זמן ארוך אך מוגדר וברור, בניגוד למצב הקודם שיכול היה להימשך עשרות שנים.",
      },
      {
        q: "מה ההבדל בין חדלות פירעון להוצאה לפועל?",
        a: "בהוצאה לפועל הנושים פועלים לגביית החוב. בחדלות פירעון יש הליך כולל שמטפל בכל החובות יחד, מקפיא את הגבייה ומאפשר הפטר. רוב התיקים בהוצאה לפועל מסתיימים היום במעבר לחדלות פירעון.",
      },
      {
        q: "האם אצלי בתיק כדאי הליך חדלות פירעון?",
        a: "ההחלטה תלויה בהיקף החוב, הסיכויים לפרוע אותו במצב הנוכחי, נכסי החייב והאינטרסים האישיים. בפגישה הראשונה ניתן לכם תשובה ברורה — לעיתים נמליץ דווקא על הסדר חוב, לעיתים על הליך מלא.",
      },
    ],
    ctaTitle: "שקועים בחובות?",
    ctaText: "אל תמשיכו לסבול לבד. פנו אלינו לפגישה ראשונית — קיים פתרון.",
  },

  enforcement: {
    slug: "enforcement",
    pageTitle: "עורך דין הוצאה לפועל בבאר שבע | משרד וידבסקי ושות׳",
    metaDescription:
      "עורך דין הוצאה לפועל בבאר שבע — גביית חובות, ביצוע פסקי דין, מימוש שטרות וייצוג חייבים. ניסיון רב ויעילות בשני הצדדים של המתרס.",
    breadcrumb: "הוצאה לפועל",
    h1: "עורך דין הוצאה לפועל",
    heroSubtitle:
      "מגיע לכם כסף ולא משלמים לכם? נפתח נגדכם תיק הוצאה לפועל? משרד וידבסקי ושות׳ מייצג זוכים וחייבים — להגנה על האינטרסים שלכם בכל שלב.",
    introSpan: "תחום ההתמחות",
    introTitle: "ייצוג זוכים וחייבים בהוצאה לפועל",
    introParagraphs: [
      "מערכת ההוצאה לפועל היא הזרוע הביצועית של מערכת המשפט — הכלי שמאפשר לזוכים לממש פסקי דין ולגבות חובות, ולחייבים — להסדיר את חובותיהם בצורה מסודרת. הליכי הוצאה לפועל יכולים להיות מורכבים ומלחיצים, אך עם ייצוג מקצועי הם מתנהלים ביעילות ובסדר.",
      "במשרד וידבסקי ושות׳ אנו מלווים זוכים — בנקים, עסקים ויחידים — בגביית חובות בצורה אגרסיבית ויעילה. במקביל, אנו מייצגים גם חייבים — בהסדרת חובות, בקשות לאיחוד תיקים, התנגדויות, פעולות נגד עיקולים שגויים והגנה מפני נושים תוקפניים.",
    ],
    introBullets: [
      "פתיחת תיקי הוצאה לפועל וגביית חובות",
      "ביצוע פסקי דין מבית המשפט",
      "ביצוע שטרות (שיקים) שלא נפרעו",
      "מימוש משכנתאות, משכונות ועיקולים",
      "הסדרי תשלומים, איחוד תיקים והתנגדויות",
      "ייצוג חייבים מול נושים תוקפניים",
    ],
    cardsTitle: "תחומי הטיפול בהוצאה לפועל",
    cardsSpan: "במה אנחנו מטפלים",
    cards: [
      {
        icon: "📑",
        title: "ביצוע פסקי דין",
        desc: "מימוש פסיקה לטובתכם — פעולות גבייה, עיקולים, חקירות יכולת והגעה לתוצאה.",
      },
      {
        icon: "💵",
        title: "ביצוע שטרות",
        desc: "הגשת שיקים שלא נפרעו לביצוע, מאבק בהתנגדויות וגביית הסכומים בפועל.",
      },
      {
        icon: "🏠",
        title: "מימוש משכנתאות",
        desc: "ליווי בנקים בהליכי מימוש משכנתאות, מאידך — הגנה על חייבים מפני מימוש פגום.",
      },
      {
        icon: "⛓️",
        title: "עיקולים וצווים",
        desc: "הטלת עיקולים על משכורת, רכב, נכסים וחשבונות בנק. בקשות לביטול עיקולים פגומים.",
      },
      {
        icon: "🤝",
        title: "הסדרי חוב",
        desc: "ניהול מו״מ בין זוכים לחייבים להסדרי תשלומים סבירים שמסייעים לשני הצדדים.",
      },
      {
        icon: "🛡️",
        title: "הגנה על חייבים",
        desc: "התנגדויות, איחוד תיקים, מחיקת חובות ישנים והגנה על נכסי בסיס מפני עיקול.",
      },
    ],
    processSpan: "תהליך הטיפול",
    processTitle: "איך מתנהל תיק הוצאה לפועל?",
    processSteps: [
      {
        n: "1",
        title: "בחינת התיק והאסטרטגיה",
        desc: "נבחן אם אתם זוכים או חייבים, מה היקף החוב, נכסי החייב וההזדמנויות לגבייה או להגנה.",
      },
      {
        n: "2",
        title: "הגשת הליכים מתאימים",
        desc: "פתיחת תיק, הגשת בקשות לעיקולים, חקירות יכולת — או מנגד התנגדויות, בקשות לעיכוב הליכים והסדרים.",
      },
      {
        n: "3",
        title: "ביצוע הליכי הגבייה",
        desc: "ניהול הליכי הגבייה השוטפים — אסיפות, מימוש נכסים, מו״מ עם הצד השני — עד הגעה לתוצאה.",
      },
      {
        n: "4",
        title: "סיום התיק",
        desc: "סגירת התיק לאחר גביית מלוא החוב, או סגירתו לאחר הסדר — תוך הסדרת רישומי בנק ישראל.",
      },
    ],
    faqSpan: "שאלות נפוצות",
    faqTitle: "שאלות על הוצאה לפועל",
    faqItems: [
      {
        q: "כמה זמן נמשך תיק הוצאה לפועל?",
        a: "אין משך זמן אחיד. תיקים פשוטים יכולים להסתיים תוך חודשים בודדים, ותיקים מורכבים יכולים להימשך שנים. ניהול אסטרטגי וצעדים אקטיביים מקצרים משמעותית את משך התיק.",
      },
      {
        q: "אני חייב — מה אני יכול לעשות?",
        a: "אל תתעלמו מהליכי הוצאה לפועל. אפשרויות הפעולה כוללות הסדר תשלומים סביר, איחוד תיקים, התנגדויות, חקירת יכולת אמיתית, ובמקרים מסוימים — מעבר להליך חדלות פירעון. עורך דין יכול לעצור עיקולים ולהציל אתכם.",
      },
      {
        q: "אני זוכה — איך אני גובה את הכסף?",
        a: "פסק דין לבד לא מבטיח גבייה. נדרש לפעול בהוצאה לפועל: עיקולי משכורת, חשבונות בנק, רכב ונכסים, הטלת הגבלות על החייב, ובמקרי הצורך מימוש נכסים. אנחנו מתמקדים בתוצאה.",
      },
      {
        q: "מה זה איחוד תיקים ומתי כדאי?",
        a: "איחוד תיקים מאפשר לחייב לפרוע את כל חובותיו תחת תיק מאוחד אחד, בתשלומים שנקבעים לפי יכולתו. זה כלי מצוין לחייבים עם תיקים רבים — אך לא בכל מצב הוא משתלם. נבחן יחד מה נכון לכם.",
      },
      {
        q: "האם אפשר לבטל עיקול שהוטל עלי?",
        a: "במקרים רבים — כן. עיקולים שהוטלו על נכסים מוגנים, על משכורת מתחת לרף החוקי, או בלי בסיס מספק, ניתן לבטל בהגשת בקשה מתאימה. פעולה מהירה היא קריטית.",
      },
    ],
    ctaTitle: "צריכים עורך דין הוצאה לפועל?",
    ctaText: "בין אם אתם זוכים או חייבים — צרו קשר לקבלת ייעוץ מקצועי ופתרון מותאם.",
  },
};

export const getServiceContent = (slug) => servicesContent[slug] || null;
